import React, { PropTypes, PureComponent } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';

import { H1 } from '../../../components/common/text';
import PaymentDashboard from './payment-dashboard';
import PaymentSelection from './payment-selection';

import styles from './payments.styles';
import { PALETTE } from '../../../constants';
import BlurModal from '../../../components/common/blur-modal';
import Button from '@dbk/ui-buttons';
import PaymentFilter from '../init-payments/payment-filter/payment-filter';

class Payments extends PureComponent {
  state = {
    showFailModal: false,
    failMsg: '',
    filterClicked: false
  }
  componentWillUnmount() {
    this.toggleCreateModal(false)
    this.props.payments.setRemarks('');
    this.props.payments.setPaymentReason('');
  }

  toggleCreateModal = state => this.props.payments.setCreateNewModal(state)

  createNewPayment = () => {
    this.props.payments.resetForm();
    this.props.payments.refreshPayments();
    // this.props.payments.setPosId(psPosId);
    this.toggleCreateModal(true);
    this.props.payments.setBeneficiaryIdToUpdate(null);
    this.props.payments.setExistingBeneficiaryId(null);
  }

  componentDidMount() {
   // WMCE-31199 "new Payment " button missing
   this.props.enablePaymentByPortfolioId();
   if(document.querySelector('.logo-web')){
    document.querySelector('.logo-web').focus();
  }
  if(document.querySelector('button.paymentFilterFocus')){  // Button focusable for payment filter popup
    document.querySelector('button.paymentFilterFocus').focus();
  }
  }
  toggleFilter(){
   this.setState({filterClicked: true})
  }
  
  render() {
    const { i18n: { messages },
    auth: { isPaymentCheck, vascoActivated, passwordExpired, entitlement } } = this.props;
    return (
      <div className="payment-page row">
        <div className="title-header" id="title_paymentsPage_index_test">
          <h2 secondary className="title" tabIndex={0}>{messages['app.common.pageHeader.Payments']}</h2>
          {/* <h2 className="data-title">{messages['app.common.pageTitle.dataExports']}</h2> */}

              <span className={'filterIcon'} style={{display:'flex'}}>
                {entitlement.payment && !passwordExpired && isPaymentCheck &&  vascoActivated && (
                  <Button testID="btn_payments_createNew_index_test"
                    role="button"
                    id="focusButton"
                    aria-label="NewPaymentButton"
                    size="medium"
                    onPress={() => this.createNewPayment()}>
                    {messages['app.payments.newPayment']}
                  </Button>
                )}
              <PaymentFilter />
              </span>
              
        </div>
       
        <div className="paymentDash">
          <PaymentDashboard />
        </div>
        <div className="paymentSelection">
          <PaymentSelection />
        </div>
      </div>
    )
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    payments : {
      setFilterDataSource : { $call : 'setFilterDataSource'},
      psPosId: true,
      setRemarks: { $set: 'remarks'},
      setPaymentReason: { $set: 'paymentReason'},
      setBeneficiaryIdToUpdate: { $set: 'beneficiaryIdToUpdate'},
      setExistingBeneficiaryId: { $set: 'existingBeneficiaryId' },
      setPosId: { $set: 'psPosId' },
      resetForm: { $call: 'resetForm' },
      refreshPayments: { $call: 'refreshPayments' },
      setCreateNewModal: { $set: 'createNewModal' },
    },
    changePage: { $call: 'ui.history.push' },
    enablePaymentByPortfolioId : { $call: 'auth.enablePaymentByPortfolioId'},
    auth: {
      entitlement: true,
      passwordExpired: true,
      isPaymentCheck: true,
      vascoActivated: true,
    },
  },
})(Payments);

